import React, { useState , useEffect, useRef,Fragment} from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink,Collapse, Row, Col,Card, Button,Container,Input } from "reactstrap";
import { connect } from "react-redux";
import classnames from "classnames";
import {
  GridView,
  FromFields,
  FromEditFields,
  UsereviewRatingTable,
  } from "../../employee/index";
import { GridViewAsset, EmployeeAssets } from "./index";
import TableWithSortPagtn from "../../common/TableWithSortPagtn";
import useFormValidation from "../../common/useFormValidation";
import { addEditAssetExcel } from "../../../redux/actions/employee/employee.action";
const AssetTabs = (props) => {
  const [activeTab, setActiveTab] = useState("1");
  const { addEditAssetExcel } = props;
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  // const { reviewrating } = props.reviewrating;



  const [reviewArr, setreviewArr] = useState([]);
  const [leaveTypeArray, setLeaveTypeArray] = useState("");
  const [employeefile, setFile] = useState("");



  const [selectedReview, setSelectedReview] = useState({ id: "", val: "" });
  const [ReviewInputFields, setReviewFields] = useState([]);

  const [isOpenGridView, setIsOpenGridView] = useState(true);
  const [isOpenListView, setIsOpenListView] = useState(false);
  const [isOpenForm, setIsOpenForm] = useState(true);
  const [formValidationState, setFormValidationState] = useState({});
  const callValidation = useRef(false);
  const [val, setVal] = useState();

  // custom hook.
  const { formValidation, isFormValid } = useFormValidation(
    formValidationState
  );

  useEffect(() => {
    // calls when form submited`
    callValidation.current && callBackAfterValidation();
  }, [formValidation]);

 // call the employee type data

useEffect(() => {
  // setreviewArr(reviewrating);
  setReviewFields([
    {
      label: "Rating",
      type: "file",
      placeholder: "Enter Rating",
      name: "employeeexe", // this name should be equal to the leave type array key's.
      handleOnChange: (val) => {
        setFile(val);
        setVal(val);
      },
    },
    
  ]);
}, []);

const toggleImport = () => {
  // setSelectedDesg({ id: "", val: "" });
  setIsOpenGridView(!isOpenGridView);
  setIsOpenForm(!isOpenForm);
};

//  on click the tile ,open the from with data filed.
const handleEditReview = React.useCallback((val, id) => {
  setSelectedReview({ id: id, val: val });
  // toggle();
}, []);

// handle the dropdown change in list view.
const handleDropDownBtnOnChange = (val) => {

};

const handleAddLeaves = (e) => {
  e.preventDefault();
  let formData = {
    review: employeefile,
   
  };
 // addReviewRating(formData);
 toggleImport();
};

const handleUpdateLeaves = (e) => {
  e.preventDefault();
 // updateReviewRating(selectedReview.val);
  setSelectedReview({ id: "", val: "" });
  toggleImport();
};
// delete

const onClickToggleFromTable = React.useCallback(() => {
  setIsOpenListView((prevState) => !prevState);
  setIsOpenForm((prevState) => !prevState);
}, [setIsOpenListView, setIsOpenForm]);


const formValidationOnSubmitAdd = (e) => {

  e.preventDefault();
  let formValidationList = {
    // key name should be same as the input field name.
    employeeexe: {
      required: true,
      isValid: true,
      value: employeefile,
      errorMessage: "",
    },
    
  };
  setFormValidationState(formValidationList); //this set call the custom hook useFormValidation.
  callValidation.current = true;
};
const formValidationOnSubmitUpdate = (e) => {
  e.preventDefault();
  let formValidationList = {
    // key name should be same as the input field name.
    rating: {
      required: true,
      isValid: true,
      value: selectedReview.val.rating,
      errorMessage: "",
    },
   
  };
  setFormValidationState(formValidationList); //this set call the custom hook useFormValidation.
  callValidation.current = true;
};


const callBackAfterValidation = async () => {

  if (isFormValid) {
    // if form valid.
    if (selectedReview.id !== "") {
     // updateReviewRating(selectedReview.val);
      setSelectedReview({ id: "", val: "" });
      toggleImport();
    } else {
      const formData = new FormData();
      formData.append("formfile",employeefile);

      addEditAssetExcel(formData);
      toggleImport();
    }
  }
};
  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => {
              toggle("1");
            }}
          >
            All Assets
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => {
              toggle("2");
            }}
          >
            Employee Assets
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "3" })}
            onClick={() => {
              toggle("3");
            }}
          >
            Assets Excel Import
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <GridViewAsset
            assets={props.assets}
            itemList={props.itemList}
            openAssetItem={props.openAssetItem}
            openAddForm={props.openAddForm}
            handleSelectedAsset={props.handleSelectedAsset}
            handleDel={props.handleDel}
          ></GridViewAsset>

        </TabPane>
        <TabPane tabId="2">
          <EmployeeAssets
            assets={props.assets}
            empList={props.userList}
          ></EmployeeAssets>
        </TabPane>
        <TabPane tabId="3">
        <Fragment>
    <Container>
   
    <hr></hr>
    <Row>
      {/* <Col>
      <Card
                  body
                  inverse
                  className="card-tile"
                 onClick={toggleImport}
                >
                <i className="fas fa-plus text-center"></i>
                </Card>
      </Col> */}
    </Row>
   
    <Collapse isOpen={isOpenForm}>
    <Input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
<br/>
                <Button
      color=""
      className="btn-admin-settings"
      onClick={formValidationOnSubmitAdd}
    >
Submit
    </Button>
    </Collapse>
<Collapse>

{/* <GridView
        pagaData={reviewArr}
       
        isOpenGridView={isOpenGridView}
       
        toggle={toggleImport}
  
        reset={() => setVal(() => "")}
      ></GridView> */}
</Collapse>
    {/* <Collapse isOpen={isOpenListView}>
      <TableWithSortPagtn thead={thead} trow={trow} pageSize={5}></TableWithSortPagtn>
    </Collapse> */}
    </Container>
    </Fragment>
        </TabPane>
      </TabContent>
    </div>
  );
};
const mapStateToProps = (state) => ({
  reviewrating: state.adminSettingReducer,
});
export default connect(mapStateToProps, {
  addEditAssetExcel
})(AssetTabs);
// export default ;